<template>
    <div class="telegram-invitation-instructions">
        <h6>Как добавить сотрудника вручную</h6>
        <ol class="pl-3 mb-2">
            <li>Если мешает конфиденциальность, попросите сотрудника открыть в Telegram <strong>Настройки → Конфиденциальность → Приглашения</strong> (в некоторых версиях — «Группы и каналы») и добавить <strong>конкретного администратора</strong>, который будет его добавлять, в исключение «Всегда разрешать». Разрешать приглашения всем не нужно.</li>
            <li>Администратор открывает группу → нажимает её название → <strong>Добавить участников</strong>. Находит сотрудника по контакту или имени пользователя, проверяет аккаунт и добавляет его напрямую. Если аккаунт не найден, уточните у сотрудника его имя пользователя в Telegram.</li>
            <li>Проверьте, что сотрудник появился в списке участников. Если ему нужны права администратора, владелец группы или администратор с соответствующим правом назначает их отдельно.</li>
        </ol>
        <p class="mb-2">Нет доступа к группе или права добавлять участников — обратитесь к её владельцу или администратору.</p>
        <p class="mb-0"><strong>Не используйте пригласительные ссылки:</strong> их можно переслать посторонним. Добавляйте только проверенные аккаунты напрямую.</p>
    </div>
</template>
<script>
export default {};
</script>
<style scoped>
.telegram-invitation-instructions {font-size: 14px; line-height: 1.5;}
.telegram-invitation-instructions h6 {font-weight: 600;}
.telegram-invitation-instructions li + li {margin-top: 8px;}
</style>
